import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { common } from '@qwyk/models';

@Component({
    standalone: true,
    imports: [NgClass, TooltipModule, TranslateModule, FontAwesomeModule],
    selector: 'qwyk-list-table-switcher',
    templateUrl: './list-table-switcher.component.html',
    styleUrls: ['./list-table-switcher.component.scss'],
})
export class ListTableSwitcherComponent {
    public readonly ViewMode = common.ViewMode;
    @Input() public view: common.ViewMode;
    @Input() public class: string;
    @Output() public viewChange: EventEmitter<common.ViewMode> =
        new EventEmitter<common.ViewMode>();

    public setView(view: common.ViewMode): void {
        this.view = view;
        this.viewChange.emit(this.view);
    }
}
